export default __webpack_public_path__ + "static/media/residential.cafecd31.jpg";